module.exports = __webpack_public_path__ + "media/backgrounds/marek-piwnicki-YqelP6p-BSM-unsplash-131dfaa8.jpg";